<div class="layout-footer">
    <img src="https://storage.googleapis.com/mixo-sites/images/file-18b706d4-1da8-4eee-abbc-1428cebea373.png" alt="Logo" height="20" class="mr-2"/>
    by
    <span class="font-medium ml-2">Otimiza.ai - v1.1.0</span>
</div>
